import React from 'react';
import styles from './styles';
import { connect } from 'react-redux';
import { Container, Typography, Tooltip } from '@material-ui/core';
import * as actionsPresentacion from '../../../../actions/nuevaPresentacion';
import BtnAdjuntar from '../../../Presentacion/Adjuntos/BtnAdjuntarArchivos';
import ListadoArchivos from '../../../Presentacion/Adjuntos/ListadoArchivos';

const liquidaciones = (props) => {
    const classes = styles();

    const { liquidacionesFiles, pathTemporal } = props;

    if (
        !props.prestadorSeleccionado ||
        props.tipoPresentacionSeleccionada === "" ||
        props.tipoPresentacionSeleccionada === 2 ||
        (props.tipoComprobanteSeleccionado !== 1 && props.tipoComprobanteSeleccionado !== '' )||
        props.tipoComprobanteSeleccionado === 2
    ) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <Container
                disableGutters={true}
                className={classes.containerTitulo}
            >
                <Typography className={classes.tituloSeccion}>
                    Listado de liquidaciones {" "}
                    {props.requeridos.liquidaciones.requerido ? "*" : ""}
                </Typography>
                <Tooltip
                    placement="right"
                    title={
                        <>
                            <strong>DETALLE DE PRESTACIONES</strong>
                            <br />
                            Extensiones permitidas: "PDF"
                            <br />
                            Extensiones opcionales: "JPG", "JPEG", y "PNG"
                            <br />
                            Requerido
                        </>
                    }
                >
                    <Typography className={classes.ayuda}>?</Typography>
                </Tooltip>
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                <BtnAdjuntar
                    extensionesAceptadas='.jpg,.jpeg,.png,.pdf'
                    multiplesArchivos={true}
                    path={pathTemporal}
                    seccion='liquidaciones'
                    archivosHandler={props.actualizarLiquidacionesFiles}
                    archivosSubidos={liquidacionesFiles}
                    deshabilitado={props.soloVista}
                />
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                <ListadoArchivos
                    seccion='liquidaciones'
                    archivosHandler={props.actualizarLiquidacionesFiles}
                    archivosSubidos={liquidacionesFiles}
                    deshabilitado={props.soloVista}
                />
                 {props.soloVista && liquidacionesFiles.length === 0 && (
                    <Typography
                        variant="caption"
                        color="primary"
                        align="center"
                        display="block"
                        style={{ fontWeight: "400" }}
                    >
                        No hay archivos cargados en esta sección
                    </Typography>
                )}
            </Container>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    liquidacionesFiles: state.nuevaPresentacionReducer.liquidacionesFiles,
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    tipoPresentacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    tipoComprobanteSeleccionado:
        state.nuevaPresentacionReducer.tipoComprobantesSeleccionado,
    requeridos: state.nuevaPresentacionReducer.requeridos
});

const actionCreators = {
    actualizarLiquidacionesFiles:
        actionsPresentacion.actualizarLiquidacionesFiles,
};

export default connect(mapStateToProps, actionCreators)(liquidaciones);
